export const MAIN_API = "https://Farm-Tube-Backend.surajgupta07.repl.co";
export const VIDEO_API = `${MAIN_API}/videos`